import { createContext, useContext } from 'react';
import type { ResolvedRegistry } from '~/platform/registry/registry';

export const RegistryContext = createContext<ResolvedRegistry | null>(null);

export const useRegistry = (): ResolvedRegistry => {
  const registry = useContext(RegistryContext);
  if (!registry) throw new Error('useRegistry must be used inside the AppShell');
  return registry;
};
